import SystemMeter from '@components/_shared/SystemMeter';
import MasterTrackerDetail from '@components/_shared/Tracker/MasterTrackerDetail';
import MasterTrackerList from '@components/_shared/Tracker/MasterTrackerList';
import TrackerList from '@components/_shared/Tracker/TrackerList';
import { CurrentTrackerDeviceProvider } from '@hooks/useCurrentTrackerDevice';
import { ReactElement } from 'react';

function TRACKERS(): ReactElement {
  return (
    <CurrentTrackerDeviceProvider>
      <div className='home-row'>
        <div className='fcol'>
          <SystemMeter />
          <MasterTrackerList />
        </div>
        <div className='fcol'>
          <MasterTrackerDetail />
          <TrackerList />
        </div>
      </div>
    </CurrentTrackerDeviceProvider>
  );
}

export default TRACKERS;
